import { type ErrorMessage } from '@/features/shared/utils/dataFetching/types'
import { isObject } from '@/features/shared/utils/isObject'

export const isErrorMessage = (error: unknown): error is ErrorMessage =>
  isObject(error) && 'message' in error
